import React, { FC, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

// Shared UI Library Components
import { CustomIcon, CustomTooltip, EIconName } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './header-menu.scss';

// Config
import { CLayoutHeaderMenuList } from '../../../../configs/components/main-layout.config';

type THeaderMenuProps = {
  pathState: {
    current: string;
    prev: string;
  },
  unreadCount: number;
  withLabels?: boolean;
  onItemClick?: () => void
}

export const HeaderMenu: FC<THeaderMenuProps> = (
  { pathState: { current: currentPath }, unreadCount, withLabels = false, onItemClick = () => {} }: THeaderMenuProps
): JSX.Element => {

  const navigate = useNavigate();

  const changeMenuHandler = (path: string): void => {
    onItemClick();
    navigate(path);
  }

  const getDynamicActiveIcon = (path: string, icon: ReactNode, isActive: boolean): ReactNode => {
    if (path === 'notifications' && !!unreadCount && !isActive) {
      return <CustomIcon name={ EIconName.NotificationExist }/>
    }
    return icon;
  }

  return (
    <div className="header-menu">
      {
        CLayoutHeaderMenuList.map(({ icon, path, activeIcon, label }) => {
          const isActive = currentPath.includes(path);
          const dynamicIcon = getDynamicActiveIcon(path, icon, isActive);
          return (
            <CustomTooltip key={ Math.random() } placement={ withLabels ? 'right' : 'bottom' } title={ label }>
              <div
                className={ `header-menu--item ${ withLabels ? 'mobile-item' : '' } ${ isActive ? ' active-item' : '' }` }
                onClick={ () => changeMenuHandler(path) }>
                <span className="icon-item">{ isActive ? activeIcon : dynamicIcon }</span>
                { withLabels ? label : '' }
              </div>
            </CustomTooltip>
          )
        })
      }
    </div>
  )
};
